<template>
    <div>
        <div class="vx-row">
            <div class="vx-col w-full mb-base">
                <vx-card>
                    <div class="breadcrumbs">
                        <span v-for="(ancestor, index) in listOfAncestors" v-bind:key="ancestor.uuid" class="ancestor"
                              v-on:click="index !== listOfAncestors.length - 1 ? $router.push({query: {uuid:ancestor.uuid}}) : null"
                              v-bind:class="{ active: index === listOfAncestors.length - 1 }">
                            {{ancestor.first_name}} {{ancestor.last_name}} <span
                            v-if="index !== listOfAncestors.length - 1">/ </span>
                        </span>
                    </div>
                </vx-card>
            </div>
        </div>
        <div class="vx-row">
            <div class="vx-col w-full mb-base">
                <div class="vx-card">
                    <div class="vx-card__header">
                        <div class="vx-card__title">
                            <h4 class="mb-4">Referrals</h4>
                        </div>
                    </div>
                    <div class="vx-row">
                        <div class="vx-col mb-base">
                            <vs-input id="search-box" v-on:input="filterChanged" icon="search" size="large"
                                      v-model="searchInput"
                                      label-placeholder="Search"
                                      class="ml-6 mt-6"/>
                        </div>
                        <div class="vx-col mb-base grid-filter-icon-wrapper" v-on:click="showFilters = !showFilters">
                            <feather-icon icon="FilterIcon" svgClasses="w-6 h-6 mt-6"/>
                        </div>
                    </div>

                    <div v-if="listOfReferrers && listOfReferrers.length > 0" class="vx-row ml-6" v-bind:class="{'mb-base': showFilters}">
                        <vs-checkbox class="mr-6" v-on:change="setActiveStatus('active', $event)"
                                     v-model="showMembActive">
                            Active membership
                        </vs-checkbox>
                        <vs-checkbox v-on:change="setActiveStatus('not-active', $event)" v-model="showMembInactive">
                            Inactive membership
                        </vs-checkbox>
                    </div>

                    <div class="vx-row ag-grid-columns-filter-wrapper" v-bind:class="{ show: showFilters}">
                        <div class="vx-col ml-6">
                            <span v-for="(column, index) in columnsFilter" v-bind:key="index"
                                  class="filter-checkbox-wrapper mb-2">
                                <vs-checkbox v-model="column.show"
                                             @change="setColumnsVisibility()">{{column.name}}</vs-checkbox>
                            </span>
                        </div>
                    </div>
                    <ag-grid-vue
                        class="ag-theme-material w-100 my-4 ag-grid-table clickable-grid"
                        :columnDefs="referrersListColumns"
                        :rowData="refereesData"
                        :defaultColDef="defaultColDef"
                        :gridOptions="gridOptions"
                        :components="referrerComponents"
                        rowSelection="single"
                        @rowClicked="onUserRowSelected"
                        colResizeDefault="shift"
                        :animateRows="true"
                        :pagination="true"
                        :paginationPageSize="paginationPageSize"
                        :suppressPaginationPanel="true"
                        overlayNoRowsTemplate=" "
                        :isExternalFilterPresent="isExternalFilterPresent"
                        :doesExternalFilterPass="doesExternalFilterPass"
                        @gridReady="setGridSize($event)">
                    </ag-grid-vue>
                    <vs-pagination
                        :total="totalPages"
                        :max="paginationMaxSize"
                        v-model="currentPage"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import {AgGridVue} from 'ag-grid-vue';
    import '../../assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
    import CellRendererAvatar from '../../views/cell-renderer/CellRendererAvatar';
    import CellRendererMembership from '../../views/cell-renderer/CellRendererMembership';
    import CellRendererOverview from '../../views/cell-renderer/CellRendererOverview';
    import RestService from '../../services/RestService';
    import {Role} from "../../enums/role";

    export default {
        name: "referrals-data",
        components: {
            AgGridVue,
            CellRendererAvatar,
            CellRendererMembership,
            CellRendererOverview
        },
        async beforeMount() {
            await this.setReferrersAndAncestor();
        },
        methods: {
            async setReferrersAndAncestor() {
                let uuid = this.$route.query.uuid || this.$store.state.AppActiveUser.uid;

                let referrersResponse = null;
                if (this.$store.state.AppActiveUser.userRole === Role.User) {
                    referrersResponse = await RestService.getReferrers(uuid);

                } else if (this.$store.state.AppActiveUser.userRole === Role.Admin) {
                    referrersResponse = await RestService.getUsersReferrals(uuid);
                }

                if (referrersResponse && referrersResponse.success) {
                    this.listOfReferrers = referrersResponse.data.referrals;
                    this.listOfAncestors = referrersResponse.data.ancestors;
                } else {
                    this.$router.push('/' + this.$store.state.AppActiveUser.userRole).catch(() => {
                    });
                }
            },

            setGridSize(params) {
                if (window.innerWidth > 1024)
                    params.api.sizeColumnsToFit();
                this.gridOptions.api.setDomLayout('autoHeight');
            },

            onUserRowSelected(event) {
                if (this.$store.state.AppActiveUser.userRole === Role.User) {
                    this.$router.push({path: '/user/downline', query: {uuid: event.node.data.uuid}});
                } else if (this.$store.state.AppActiveUser.userRole === Role.Admin) {
                    this.$router.push({path: '/admin/members/referrals', query: {uuid: event.node.data.uuid}});
                }
            },

            filterChanged() {
                this.gridApi.setQuickFilter(document.getElementById('search-box').value);
            },

            setColumnsVisibility() {
                this.columnsFilter.forEach(c => {
                    this.gridOptions.columnApi.setColumnVisible(c.id, c.show);
                });
                // TODO this needs optimization
                if (window.innerWidth > 1024)
                    this.gridApi.sizeColumnsToFit();
            },

            setActiveStatus(value, event) {
                if (value === 'active') {
                    this.showMembActive = event.target.checked;
                } else {
                    this.showMembInactive = event.target.checked;
                }

                if (this.showMembInactive && this.showMembActive) {
                    this.activeFilterChanged('all');
                } else if (this.showMembActive && !this.showMembInactive) {
                    this.activeFilterChanged('active');
                } else if (!this.showMembActive && this.showMembInactive) {
                    this.activeFilterChanged('not-active');
                } else {
                    this.activeFilterChanged('null');
                }
            },

            activeFilterChanged(newVal) {
                this.membStatus = newVal;

                if (this.gridApi) {
                    this.gridApi.onFilterChanged();
                }
            },

            isExternalFilterPresent() {
                return this.membStatus !== 'all';
            },

            doesExternalFilterPass(node) {
                switch (this.membStatus) {
                    case 'active':
                        return node.data.active === true
                    case 'not-active':
                        return node.data.active === false
                    case 'null':
                        return false;
                    default:
                        return true;
                }
            },
        },
        computed: {
            refereesData() {
                return this.listOfReferrers;
            },
            paginationPageSize() {
                return 10; // TODO maybe change
            },
            paginationMaxSize() {
                if (this.gridApi) {
                    let pagesNr = this.gridApi.paginationGetTotalPages();
                    return pagesNr < 8 ? pagesNr + 1 : 7; // TODO maybe change this
                } else
                    return 1;
            },
            totalPages() {
                if (this.gridApi)
                    return this.gridApi.paginationGetTotalPages();
                else
                    return 0;
            },
            currentPage: {
                get() {
                    if (this.gridApi)
                        return this.gridApi.paginationGetCurrentPage() + 1;
                    else
                        return 1;
                },
                set(val) {
                    this.gridApi.paginationGoToPage(val - 1);
                }
            }
        },
        mounted() {
            this.gridApi = this.gridOptions.api;
            this.columnsFilter = this.referrersListColumns.filter(c => !c.hideFromFilter).map(c => {
                return {id: c.field, name: c.headerName, show: true};
            });
        },
        data() {
            return {
                gridOptions: {},
                gridApi: null,
                listOfAncestors: null,
                referrersListColumns: [
                    // {
                    //     headerName: 'User',
                    //     field: 'uuid',
                    //     filter: true,
                    //     cellRendererFramework: 'CellRendererAvatar',
                    //     cellClass: 'text-center'
                    // },
                    {
                        headerName: 'First name',
                        field: 'first_name',
                    },
                    {
                        headerName: 'Last name',
                        field: 'last_name',
                    },
                    {
                        headerName: 'Downline',
                        field: 'descendants'
                    },
                    {
                        headerName: 'Membership status',
                        field: 'active',
                        cellRendererFramework: 'CellRendererMembership',
                    },
                    {
                        headerName: 'User overview',
                        cellRendererFramework: 'CellRendererOverview',
                        width: 200,
                        hideFromFilter: true
                    }
                ],
                defaultColDef: {
                    sortable: true,
                    editable: false,
                    resizable: true,
                    suppressMenu: true
                },
                columnsFilter: [],
                showFilters: false,
                membStatus: 'all',
                showMembActive: true,
                showMembInactive: true,
                listOfReferrers: null,
                searchInput: '',
                referrerComponents: {
                    CellRendererAvatar
                }
            }
        },
        watch: {
            async $route() {
                this.listOfReferrers = null; // todo make a spinner when loading?
                this.setReferrersAndAncestor();
            }
        }
    }
</script>

<style scoped>
    .ancestor {
        cursor: pointer;
    }

    .ancestor.active {
        cursor: default;
        color: #D5A041; /*todo change to variable*/
    }
</style>
